"use strict";

class AboutUtil {
  constructor() {}

  isOrderEnabled(orderAcceptStatus) {
    // 「注文 受付中」の場合のみ true
    if (orderAcceptStatus === ORDER_ACCEPT_STATUS.ACCEPTING) {
      return true;
    }
    return false;
  }
}

// 注文受付状態
const ORDER_ACCEPT_STATUS = {
  NOT_ACCEPTED: 0, //注文 受付停止中
  SUSPENDED: 1, //注文 一時停止中
  ACCEPTING: 2, //注文 受付中
};

const aboutUtil = new AboutUtil();
export { aboutUtil, ORDER_ACCEPT_STATUS };
